import { CTA, Arrow, serif, shell, Eyebrow, Title } from "../components/CommonComponents";

export default function Fees({ title }) {
    return (
        <section id="fees" className="bg-[#F7F2E8] py-20 sm:py-24 lg:py-28">
            <div className={`${shell} grid overflow-hidden rounded-[8px_34px_8px_8px] bg-white lg:grid-cols-[1fr_0.75fr]`}>
                <div className="p-8 sm:p-10 lg:p-12">
                    <Eyebrow>Financial information</Eyebrow>
                    <Title highlight={"Fees & Scholarship"} position="end">
                        {title}
                    </Title>
                    <p className="mt-6 text-base leading-8 text-[#65717D]">
                        Programme fees, payment schedules and applicable scholarship
                        opportunities are communicated by the admissions team according to
                        the current academic session.
                    </p>
                </div>
                <aside className="bg-[#071A2F] p-8 text-white sm:p-10">
                    <span className="text-sm font-bold uppercase tracking-[0.14em] text-[#D5AD57]">
                        Need current fee details?
                    </span>
                    <p className={`${serif} mt-6 text-3xl leading-tight`}>
                        Request the latest fee structure and scholarship guidance.
                    </p>
                    <a
                        href="/contact-us"
                        className="mt-9 inline-flex min-h-14 items-center gap-6 rounded-[3px_18px_3px_3px] bg-[#D5AD57] px-6 text-sm font-bold text-[#071A2F]"
                    >
                        Talk to admissions <Arrow />
                    </a>
                </aside>
            </div>
        </section>
    );
}
